import {
  CARRIER_BOOKING_LINK_EDIT_ROUTE_NAME,
  CARRIER_BOOKING_LINK_ROUTE_NAME,
  CarrierHashBookingRouteName,
} from '@/utils/carrier.utils'

export const publicPages = [
  'index',
  'login',
  'carrier-login',
  'carrier-verification',
  'carrier-blocked',
  'carrier-bookings-disabled',
  'login-social-microsoft',
  'error',
  'register',
  'password-reset',
  'password-reset-confirm-uid-token',
  'carrier-chash-auction-hash',
  'carrier-tender-hash',
  'carrier-request-list',
  'carrier-transport-list',
  'carrier-tender-list',
  'carrier-contract-list',
  'carrier-contract-hash',
  'carrier-booking-list',
  'carrier-booking-hash',
  'carrier-booking-edit-hash',
  ...Object.values(CarrierHashBookingRouteName),
  CARRIER_BOOKING_LINK_ROUTE_NAME,
  CARRIER_BOOKING_LINK_EDIT_ROUTE_NAME,
  'invitations-accept-invite-hash',
  'account-confirm-email-hash',
  'privacy-preferences-hash',
  'all',
]
